import React, { lazy, Suspense } from 'react';

export function lazyWithSuspense(importFunc, fallback = null, timeout = 1000) {
	const LazyComponent = lazy(importFunc);

	const Component = props => (
		<Suspense fallback={fallback}>
			<LazyComponent {...props} />
		</Suspense>
	);

	Component.preload = importFunc;

	if (timeout) {
		setTimeout(() => {
			// console.log('calling generic in lazyWithSuspense');
			importFunc();
		}, timeout);
	}

	return Component;
}
